// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1AtQb","header":"PatientBlock_header__23m7-","label":"PatientBlock_label__3xfwP","option":"PatientBlock_option__2VpjS"};